module.exports = __webpack_public_path__ + "media/images/img_consul_1-8d61640ac106262c1563f76f8280c497.jpg";